/** Route guard: only SUPERADMIN can open the wrapped route (modules in DEVELOPMENT). */
import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';
import { isSuperAdmin } from '../utils/permissions';

export default function RequireSuperAdmin({ children }: { children: ReactNode }) {
  const user = useAuthStore((s) => s.user);
  if (!isSuperAdmin(user?.role ?? '')) return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
}
